import apiClient from "../../utils/apiClient";

const LOGIN = "/login";

const login = (data) => {
  const url = `${LOGIN}`;
  return apiClient.post(url, data);
};

const loginLinkRequest = (data) => apiClient.post('/auth/magic/login', data);

const exchangeMagic = (payload) => apiClient.post('/auth/magic/exchange', payload);

const exchangeAdminMagic = (payload) => apiClient.post('/auth/admin/exchange', payload);

const logout = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("user");
  localStorage.removeItem("masterClass");
  localStorage.removeItem("is_admin_impersonation");
  localStorage.removeItem("admin_user_id");

  return Promise.resolve();
};

export const loginService = {
  login,
  loginLinkRequest,
  exchangeMagic,
  exchangeAdminMagic,
  logout
};
